import { DASHBOARD_STACK } from "./screenNames";

const sidebarConfig = {
  upper: [
    {
      title: "Dashboard",
      icon: "home_icon",
      path: DASHBOARD_STACK.HOME,
    },
    // {
    //   title: "Competitions",
    //   icon: "competitions_icon",
    //   path: DASHBOARD_STACK.COMPETITIONS,
    // },
    {
      title: "Participants",
      icon: "members_icon",
      path: DASHBOARD_STACK.MEMBERS,
    },
    {
      title: "Format",
      icon: "formats_icon",
      path: DASHBOARD_STACK.FORMAT,
    },
    {
      title: "Fixtures",
      icon: "fixtures_icon",
      path: DASHBOARD_STACK.FIXTURES,
    },
    {
      title: "Payments",
      icon: "payments_icon",
      path: DASHBOARD_STACK.PAYMENTS,
      requires: "canManagePayments",
    },
    {
      title: "Results",
      icon: "results_icon",
      path: DASHBOARD_STACK.RESULTS,
    },
    {
      title: "Standings",
      icon: "standings_icon",
      path: DASHBOARD_STACK.STANDINGS,
    },
    {
      title: "Statistics",
      icon: "statistics_icon",
      path: DASHBOARD_STACK.STATISTICS,
    },
    // {
    //   title: "Organisation Members",
    //   icon: "organisation_members_icon",
    //   path: DASHBOARD_STACK.ORGANISATION_MEMBERS,
    // },
    // {
    //   title: "Organisations",
    //   icon: "organisation_members_icon",
    //   path: DASHBOARD_STACK.ORGANISATIONS,
    // },
  ],
  lower: [
    {
      title: "Notifications",
      icon: "notifications_icon",
      path: DASHBOARD_STACK.NOTIFICATIONS,
    },
    {
      title: "Settings",
      icon: "settings_icon",
      path: DASHBOARD_STACK.SETTINGS,
    },
  ]
};

export default sidebarConfig;
